import confetti from "canvas-confetti";

// Rainbow Interests palette — mirrors the four boutiques + warm neutrals.
const RAINBOW_COLORS = [
  "#6b8e5a", // PLT green
  "#5a7ba0", // FLL blue
  "#c88ba8", // WYN pink
  "#d89a63", // PNC orange
  "#d6c9b3", // warm sand
];

// Fires a soft, on-brand burst. Feels like a little exhale, not a party trick.
export function celebrateSoft(opts = {}) {
  const { origin = { x: 0.5, y: 0.6 }, particleCount = 60 } = opts;
  confetti({
    particleCount,
    spread: 70,
    startVelocity: 32,
    gravity: 0.9,
    ticks: 140,
    scalar: 0.85,
    origin,
    colors: RAINBOW_COLORS,
    disableForReducedMotion: true,
  });
}

// A wider two-shot burst for larger moments (e.g. offer signed).
export function celebrateSigned() {
  const shoot = (x) => confetti({
    particleCount: 45,
    spread: 60,
    startVelocity: 40,
    gravity: 0.95,
    ticks: 180,
    scalar: 0.95,
    origin: { x, y: 0.55 },
    colors: RAINBOW_COLORS,
    disableForReducedMotion: true,
  });
  shoot(0.25);
  setTimeout(() => shoot(0.75), 120);
}
